import { v4 as uuidv4 } from "uuid";

const initialState = [
    {
        id: uuidv4(),
        image: "https://www.tutorialspoint.com/mongodb/images/mongodb-mini-logo.jpg",
        title: "how to learn mongodb",
        category: "mongodb",
        author: {
            profileImage:
                "https://lh3.googleusercontent.com/Nof-7R9sOUJB8C8ipUVjC4g4vSC6jB_pTxTEe6PLdlULaVDc-g2vuUvbNHShaI9NHk34L2lY7sHG6kFIShEtHa0vukvSbdn1zc7zKZTZQp6SFyWJWthYybpC6DdcKNh9o635pev5Z6CnkudJ_suNOaPNkhKOoGR6uSGSm1Z0-CL__Z_Qcfg89hsHDeoblsBn9X0Hv48TIEetSg2Ei2H53XMCa-fnithTZvYsB60XE-gd5vUq6e53TrDTZ_y1chtOYLKNMCxJFavrfxvABMHejTv2oJnMK-X8-wET8t8c76chCv6eALP3R3E4LqaiGsijSsre0JC3_zHldRkyObR8Tl7xIl2Dg3JhoksLsVvAo9MWUmY282T3bdkYEZh2CEHoDzVkRcjb5AIH4695ZxUEprjYH0cqGAvAB7MOtFAwnuWAmstKDCHtL5jqHOaOhQM3yTdJmmokLkg6mHoaaHQj_i1KnA2UAXw4-KEMulKIUJ03Rv3WmENPYV7iB0mcj0ICXwL4LtVmoUExkUzzCsbEIeHCu5wrdkh1prFWecnwr7bDkrxjKZUB2a8C_UyS7-0asTfOOaDIZEF9yr6ut6ipiWi7Yj8N5MuOH7l5WfsT-ByO04w2AGkTMm9JBJRSxTLV6OkRnS2n4VSmlAv3cKVkVzFhVHtouQuakriOFxZZZJn7eDllnngHiqj0xQ4PTFcSzQkoPw7b9XxA8DCS59vetII_XJ32DiPtlCHZEr89JgHOUls4CiVyF0QgZFwWqA=w650-h866-no?authuser=0",
            name: "haider",
        },
        date: "11 Jul, 2022  6 min read",
    },
    {
        id: uuidv4(),
        image: "https://www.php.net/images/meta-image.png",
        title: "how to learn php",
        category: "php",
        author: {
            profileImage:
                "https://www.mantruckandbus.com/fileadmin/_processed_/2/b/csm_19-09_startseite_interviewkachel_324_224_3_726a3e77d5.jpg",
            name: "monir",
        },
        date: "11 Jul, 2022  6 min read",
    },
    {
        id: uuidv4(),
        image: "https://www.iwebnext.com/imag/core_php_img.png",
        title: "how to learn php core",
        category: "php",
        author: {
            profileImage:
                "https://www.mantruckandbus.com/fileadmin/_processed_/2/b/csm_19-09_startseite_interviewkachel_324_224_3_726a3e77d5.jpg",
            name: "monir",
        },
        date: "11 Jul, 2022  6 min read",
    },
    {
        id: uuidv4(),
        image: "https://www.edureka.co/blog/wp-content/uploads/2019/07/express-logo.png",
        title: "how to learn express js",
        category: "express js",
        author: {
            profileImage:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRar9_7AALlR-ZTpH0LW9JKiOBE3QeqnnGhBJuUDQ4VKBXJGmy6oVYvdWh1BNZDyKZBvd0&usqp=CAU",
            name: "nasren",
        },
        date: "11 Jul, 2022  6 min read",
    },

    {
        id: uuidv4(),
        image: "https://redux.js.org/img/redux-logo-landscape.png",
        title: "how to learn redux",
        category: "redux",
        author: {
            profileImage:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRar9_7AALlR-ZTpH0LW9JKiOBE3QeqnnGhBJuUDQ4VKBXJGmy6oVYvdWh1BNZDyKZBvd0&usqp=CAU",
            name: "nasren",
        },
        date: "11 Jul, 2022  6 min read",
    },
    {
        id: uuidv4(),
        image: "https://cdn-images-1.medium.com/max/1250/1*mNEXWcw_Jza8ump478KiqA.png",
        title: "how to learn sql",
        category: "sql",
        author: {
            profileImage:
                "https://lh3.googleusercontent.com/Nof-7R9sOUJB8C8ipUVjC4g4vSC6jB_pTxTEe6PLdlULaVDc-g2vuUvbNHShaI9NHk34L2lY7sHG6kFIShEtHa0vukvSbdn1zc7zKZTZQp6SFyWJWthYybpC6DdcKNh9o635pev5Z6CnkudJ_suNOaPNkhKOoGR6uSGSm1Z0-CL__Z_Qcfg89hsHDeoblsBn9X0Hv48TIEetSg2Ei2H53XMCa-fnithTZvYsB60XE-gd5vUq6e53TrDTZ_y1chtOYLKNMCxJFavrfxvABMHejTv2oJnMK-X8-wET8t8c76chCv6eALP3R3E4LqaiGsijSsre0JC3_zHldRkyObR8Tl7xIl2Dg3JhoksLsVvAo9MWUmY282T3bdkYEZh2CEHoDzVkRcjb5AIH4695ZxUEprjYH0cqGAvAB7MOtFAwnuWAmstKDCHtL5jqHOaOhQM3yTdJmmokLkg6mHoaaHQj_i1KnA2UAXw4-KEMulKIUJ03Rv3WmENPYV7iB0mcj0ICXwL4LtVmoUExkUzzCsbEIeHCu5wrdkh1prFWecnwr7bDkrxjKZUB2a8C_UyS7-0asTfOOaDIZEF9yr6ut6ipiWi7Yj8N5MuOH7l5WfsT-ByO04w2AGkTMm9JBJRSxTLV6OkRnS2n4VSmlAv3cKVkVzFhVHtouQuakriOFxZZZJn7eDllnngHiqj0xQ4PTFcSzQkoPw7b9XxA8DCS59vetII_XJ32DiPtlCHZEr89JgHOUls4CiVyF0QgZFwWqA=w650-h866-no?authuser=0",
            name: "haider",
        },
        date: "11 Jul, 2022  6 min read",
    },
    {
        id: uuidv4(),
        image: "https://miro.medium.com/max/1400/1*xdo0UBpyszvD7-7EH4TkIA.png",
        title: "how to learn node js",
        category: "node js",
        author: {
            profileImage:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRar9_7AALlR-ZTpH0LW9JKiOBE3QeqnnGhBJuUDQ4VKBXJGmy6oVYvdWh1BNZDyKZBvd0&usqp=CAU",
            name: "nasren",
        },
        date: "11 Jul, 2022  6 min read",
    },
    {
        id: uuidv4(),
        image: "https://miro.medium.com/max/1050/1*i3hzpSEiEEMTuWIYviYweQ.png",
        title: "how to learn react",
        category: "react",
        author: {
            profileImage:
                "https://www.mantruckandbus.com/fileadmin/_processed_/2/b/csm_19-09_startseite_interviewkachel_324_224_3_726a3e77d5.jpg",
            name: "monir",
        },
        date: "11 Jul, 2022  6 min read",
    },
    {
        id: uuidv4(),
        image: "https://kinsta.com/wp-content/uploads/2022/02/postgres-logo.png",
        title: "how to learn postgresql",
        category: "postgresql",
        author: {
            profileImage:
                "https://lh3.googleusercontent.com/Nof-7R9sOUJB8C8ipUVjC4g4vSC6jB_pTxTEe6PLdlULaVDc-g2vuUvbNHShaI9NHk34L2lY7sHG6kFIShEtHa0vukvSbdn1zc7zKZTZQp6SFyWJWthYybpC6DdcKNh9o635pev5Z6CnkudJ_suNOaPNkhKOoGR6uSGSm1Z0-CL__Z_Qcfg89hsHDeoblsBn9X0Hv48TIEetSg2Ei2H53XMCa-fnithTZvYsB60XE-gd5vUq6e53TrDTZ_y1chtOYLKNMCxJFavrfxvABMHejTv2oJnMK-X8-wET8t8c76chCv6eALP3R3E4LqaiGsijSsre0JC3_zHldRkyObR8Tl7xIl2Dg3JhoksLsVvAo9MWUmY282T3bdkYEZh2CEHoDzVkRcjb5AIH4695ZxUEprjYH0cqGAvAB7MOtFAwnuWAmstKDCHtL5jqHOaOhQM3yTdJmmokLkg6mHoaaHQj_i1KnA2UAXw4-KEMulKIUJ03Rv3WmENPYV7iB0mcj0ICXwL4LtVmoUExkUzzCsbEIeHCu5wrdkh1prFWecnwr7bDkrxjKZUB2a8C_UyS7-0asTfOOaDIZEF9yr6ut6ipiWi7Yj8N5MuOH7l5WfsT-ByO04w2AGkTMm9JBJRSxTLV6OkRnS2n4VSmlAv3cKVkVzFhVHtouQuakriOFxZZZJn7eDllnngHiqj0xQ4PTFcSzQkoPw7b9XxA8DCS59vetII_XJ32DiPtlCHZEr89JgHOUls4CiVyF0QgZFwWqA=w650-h866-no?authuser=0",
            name: "haider",
        },
        date: "11 Jul, 2022  6 min read",
    },
];

export default initialState;
